export default __webpack_public_path__ + "static/media/PharmaPurchase.71fc7564.svg";